import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';

import { UntilDestroy } from '@ngneat/until-destroy';

import {
    AlertService,
    ButtonColors,
    ButtonModule,
    CheckboxModule,
    LayerService,
    NumberfieldModule,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

import { BillingMilestoneModel, ProjectModel } from '../../../../project.models';
import { RemoveBillingMilestone } from '../../../../project.state';
import { EdDatepickerComponent } from 'src/app/shared/components/forms/ed-datepicker/ed-datepicker.component';
import { RouterModule } from '@angular/router';
import { convertNumber } from 'src/app/shared/all.helpers';

@UntilDestroy()
@Component({
    selector: 'billing-milestone-delete',
    templateUrl: './billing-milestone-delete.component.html',
    styleUrls: ['./billing-milestone-delete.component.scss'],
    standalone: true,
    schemas: [],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        TextfieldModule,
        ButtonModule,
        NumberfieldModule,
        RouterModule,
        EdDatepickerComponent,
        CheckboxModule,
        NumberfieldModule,
    ],
})
export class BillingMilestoneDelete {
    public buttonColors = ButtonColors;

    public project: ProjectModel | undefined;
    public billing: Partial<BillingMilestoneModel> = {};
    public updateSoldAmount = true;

    constructor(
        private readonly layerService: LayerService,
        private readonly store: Store,
        private readonly alertService: AlertService,
    ) {}

    async valid(): Promise<void> {
        if (!this.project) return;
        this.store
            .dispatch(
                new RemoveBillingMilestone({
                    billingMilestoneId: this.billing.id!,
                    projectId: this.project.id,
                    updateSoldAmount: this.updateSoldAmount,
                }),
            )
            .subscribe({
                next: () => {
                    this.alertService.valid('Suppression', 'La facture a bien été supprimée');
                    this.close();
                },
                error: (err) => {
                    this.alertService.valid('Erreur lor de la suppression', `${err.error.message}`);
                },
            });
    }

    public set params(params: { project: ProjectModel; billing: BillingMilestoneModel }) {
        this.project = params.project;
        this.billing = params.billing;
    }

    public close() {
        this.layerService.close();
    }

    public getDiff(): string {
        const value =
            (this.project?.billingMilestones?.reduce((tot, b) => tot + b.amountExclTax, 0) ?? 0) -
            (this.billing.amountExclTax || 0);

        return convertNumber(value, 2, false);
    }
}
